var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-service"},[_c('div',{ref:"btn",staticClass:"btn",on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":require("assets/custom-service.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }